import Header from "@/components/Header/Header";
import HeaderTop from "@/components/Header/HeaderTop/Header-Top";
import PopupMobileMenu from "@/components/Header/PopupMobileMenu";
import Home from "@/components/Home/Home";
import Service from "@/components/Service/Service";
import Context from "@/context/Context";
import Separator from "../separator";
import Timeline from "@/components/Timeline/Timeline";
import Split from "@/components/Split/Split";
import Pricing from "@/components/Pricing/Pricing";
import Accordion from "@/components/Accordion/Accordion";
import Brands from "@/components/Brands/Brands";
import CallToAction from "@/components/CallToAction/CallToAction";
import Footer from "@/components/Footer/Footer";
import Copyright from "@/components/Footer/Copyright";
import PageHead from "../Head";
import Modal from "@/components/Common/Modal";


export async function getStaticProps(context) {
  return {
    props: {
      messages: (await import(`@/messages/${context.locale}.json`)).default
    }
  };
}
export default function HomePage({messages}) {
  return (
    <>
      <PageHead title="Anasayfa" />

      <main className="page-wrapper">
        <Context>
          <HeaderTop messages={messages}/>
          <Header
            headerTransparent="header-not-transparent"
            headerSticky="header-sticky"
            btnClass="btn-small round"
            messages={messages}
          />
          <PopupMobileMenu messages={messages}/>
          <Modal messages={messages}/>
          <Home messages={messages}/>
          <Service messages={messages}/>
          <Separator top={true} />
          <Timeline messages={messages}/>
          <Separator top={false} />
          <Split messages={messages}/>
          <Separator top={true} />
          <Pricing messages={messages}/>
          <Separator top={true} />
          <Accordion isHead={true} messages={messages}/>
          <Separator top={false} />
          <Brands messages={messages}/>
          <Separator top={true} />
          <CallToAction messages={messages}/>

          <Footer messages={messages}/>
          <Copyright messages={messages}/>
        </Context>
      </main>
    </>
  );
};
